/* Formelle SE – shipping fee on 1 pair, free shipping on bundles.
   Display only: the 49 kr is charged by the Shopify shipping rate (below 698 SEK). */
(function () {
  var CFG = {
    fee: 49,
    freeFrom: 1,                                  // tier index (0-based) that ships free
    atc: window.Formelle.strings.shippingSingleAtc,
    upsell: window.Formelle.strings.shippingUpsell,
    freeLabel: window.Formelle.strings.shippingFreeLabel
  };
  function init() {
    document.querySelectorAll('.bundle[data-product-form]').forEach(function (form) {
      if (form.dataset.fmShip) return; form.dataset.fmShip = '1';
      var tiers = Array.prototype.slice.call(form.querySelectorAll('[data-tier]'));
      if (tiers.length < 2) return;
      tiers.forEach(function (tier, i) {
        var anchor = tier.querySelector('[data-tier-save]') || tier.querySelector('.tier__head');
        if (i < CFG.freeFrom) {
          tier.setAttribute('data-ship-fee', CFG.fee);
          var btn = document.createElement('button');
          btn.type = 'button'; btn.className = 'tier__upsell'; btn.textContent = CFG.upsell;
          btn.addEventListener('click', function (e) {
            e.preventDefault(); e.stopPropagation();
            var r = tiers[CFG.freeFrom].querySelector('.tier__radio');
            if (r) { r.checked = true; r.dispatchEvent(new Event('change', { bubbles: true })); }
            tiers[CFG.freeFrom].scrollIntoView({ behavior: 'smooth', block: 'center' });
          });
          anchor.insertAdjacentElement('afterend', btn);
        } else {
          var box = document.createElement('div');
          box.className = 'tier__freeship';
          box.innerHTML = '<span class="tier__freeship-icon" aria-hidden="true">🚚</span>' +
            '<span class="tier__freeship-label">' + CFG.freeLabel + '</span>' +
            '<s class="tier__freeship-old">' + CFG.fee + ' kr</s><b class="tier__freeship-new">0 kr</b>';
          anchor.insertAdjacentElement('afterend', box);
        }
      });
      var priceOf = function (tier) {
        var t = (tier.querySelector('[data-tier-price]') || {}).textContent || '';
        return t.replace(/[^\d,]/g, '').split(',')[0];
      };
      var selected = function () { return tiers.find(function (t) { return t.classList.contains('is-selected'); }); };
      var label = form.querySelector('[data-atc-label]');
      var defaultLabel = label ? label.textContent.trim() : '';
      var section = form.closest('section, .shopify-section') || document;
      var stickyPrice = section.querySelector('[data-sticky-price]');
      function apply() {
        var sel = selected(); var fee = sel && sel.hasAttribute('data-ship-fee');
        if (label && !fee) {
          var c2 = label.textContent.trim();
          if (/\+ FRAKT$/.test(c2)) label.textContent = defaultLabel;
        }
        if (label && fee) {
          var want = CFG.atc.replace('[price]', priceOf(sel));
          var cur = label.textContent.trim();
          if (cur === defaultLabel && cur !== want) label.textContent = want;
        }
        if (stickyPrice && fee && stickyPrice.textContent.indexOf('frakt') === -1 && stickyPrice.textContent.trim()) {
          stickyPrice.textContent = stickyPrice.textContent.split(' · ')[0] + ' + ' + CFG.fee + ' kr frakt';
        }
      }
      var mo = new MutationObserver(function () { mo.disconnect(); apply(); observe(); });
      function observe() {
        if (label) mo.observe(label, { childList: true, characterData: true, subtree: true });
        if (stickyPrice) mo.observe(stickyPrice, { childList: true, characterData: true, subtree: true });
        tiers.forEach(function (t) { mo.observe(t, { attributes: true, attributeFilter: ['class'] }); });
      }
      apply(); observe();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  window.addEventListener('load', init);
})();
